<template>
  <div class="import-export-result-page">
    <div class="page-header">
      <div class="header-left">
        <el-button icon="el-icon-arrow-left" @click="goBack">返回</el-button>
        <span class="page-title">导出结果</span>
      </div>
    </div>

    <div class="search-area">
      <el-form :model="filterForm" inline>
        <el-form-item label="文件名称">
          <el-input v-model="filterForm.fileName" placeholder="请输入文件名称" style="width: 200px;" />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="filterForm.status" placeholder="请选择状态" style="width: 150px;">
            <el-option label="全部" value="" />
            <el-option label="成功" value="成功" />
            <el-option label="失败" value="失败" />
            <el-option label="处理中" value="处理中" />
            <el-option label="已取消" value="已取消" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间">
          <el-date-picker v-model="filterForm.dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 300px;" />
        </el-form-item>
        <el-form-item label="功能类型">
          <el-select v-model="filterForm.functionType" placeholder="请选择功能类型" style="width: 200px;">
            <el-option label="全部" value="" />
            <el-option label="成本账单自定义导出" value="成本账单自定义导出" />
            <el-option label="成本差异处理导入" value="成本差异处理导入" />
            <el-option label="差异单列表导出" value="差异单列表导出" />
            <el-option label="处理结果明细导出" value="处理结果明细导出" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-area">
      <el-table :data="resultList" border style="width: 100%">
        <el-table-column prop="createTime" label="创建时间" width="180" />
        <el-table-column prop="fileName" label="文件名称" min-width="250" />
        <el-table-column prop="status" label="状态" width="100">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="functionType" label="功能类型" width="180" />
        <el-table-column prop="remark" label="备注" width="100" />
        <el-table-column prop="creator" label="创建人" width="100" />
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '成功'" type="text" @click="downloadFile(scope.row)">下载</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportExportResult',
  data() {
    return {
      filterForm: {
        fileName: '',
        status: '',
        dateRange: [],
        functionType: ''
      },
      resultList: [
        { id: 1, createTime: '2026-04-30 15:31:17', fileName: '运单卡接口-20260430153109', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 2, createTime: '2026-04-30 15:31:17', fileName: '运单卡接口-20260430153109', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 3, createTime: '2026-04-30 12:37:05', fileName: '结算系统不存在-20260430123654', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 4, createTime: '2026-04-30 09:59:43', fileName: '运单卡接口0430-20260430095929', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 5, createTime: '2026-04-30 09:59:43', fileName: '运单卡接口0430-20260430095929', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 6, createTime: '2026-04-29 17:58:22', fileName: '结算系统不存在-20260429175809', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 7, createTime: '2026-04-29 10:54:47', fileName: '成本账单自定义导出列-20260429105444', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 8, createTime: '2026-04-28 20:00:15', fileName: '成本账单自定义导出列-20260428200012', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 9, createTime: '2026-04-28 18:59:59', fileName: '成本账单自定义导出列-20260428185957', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 10, createTime: '2026-04-21 10:08:51', fileName: '成本账单自定义导出列-20260421100843', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 11, createTime: '2026-04-20 13:28:12', fileName: '成本账单自定义导出列-20260420132810', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 12, createTime: '2026-04-20 11:35:03', fileName: '成本账单自定义导出列-20260420113459', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 13, createTime: '2026-04-20 11:35:03', fileName: '成本账单自定义导出列-20260420113459', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 14, createTime: '2026-04-17 10:31:42', fileName: '成本账单自定义导出列-20260417103138', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 15, createTime: '2026-04-10 13:01:34', fileName: '成本账单自定义导出列-20260410130130', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 16, createTime: '2026-04-10 11:35:46', fileName: '成本账单自定义导出列-20260410113543', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 17, createTime: '2026-04-09 16:31:47', fileName: '成本账单自定义导出列-20260409163143', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' },
        { id: 18, createTime: '2026-04-08 14:55:28', fileName: '成本账单自定义导出列-20260408145524', status: '成功', functionType: '成本账单自定义导出', remark: '成功', creator: '徐语若' }
      ]
    }
  },
  methods: {
    goBack() {
      this.$router.back()
    },
    handleSearch() {
      console.log('搜索:', this.filterForm)
    },
    handleReset() {
      this.filterForm = {
        fileName: '',
        status: '',
        dateRange: [],
        functionType: ''
      }
    },
    getStatusType(status) {
      const typeMap = {
        '成功': 'success',
        '失败': 'danger',
        '处理中': 'warning',
        '已取消': 'info'
      }
      return typeMap[status] || 'info'
    },
    downloadFile(row) {
      window.location.href = `/api/import-export/download/${row.id}`
    }
  }
}
</script>

<style scoped>
.import-export-result-page {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.page-header {
  background-color: #fff;
  padding: 12px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.page-title {
  font-size: 16px;
  font-weight: 600;
}

.search-area {
  background-color: #fff;
  padding: 16px 20px;
  margin: 12px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.table-area {
  background-color: #fff;
  margin: 0 12px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.el-table {
  font-size: 13px;
}

.el-table th {
  background-color: #fafafa;
}

.el-table .el-tag {
  padding: 2px 8px;
  font-size: 12px;
}
</style>